const theme = {
    font: {
      thin: 300,
      regular: 400,
      bold: 700
    },
    colors: {
        headings: "#707070",
        headingsLight: "#fff",
        paragraphs: '#707070',
        paragraphsLight: '#fff',
        decoration: '#b70000',
        decorationBs: '#b7000080',
        btns: '#707070',
        btnLight: '#fff',
        bullets: '#707070',
        btnBg: '#fff',
        btnBgBs: '#00000028',
        btnBgColored: '#12bb45',
        btnBgColoredBs: '#12bb457f',
        bg400: '#f8f8f8',
        bg500: '#f8f8f891',
        bg600: '#f8f8f880',
        bg700: '#707070',
    }
}
    
export default theme